import React from 'react'
import { Document, Page, View, Image, Text, StyleSheet } from '@react-pdf/renderer'
import DDJJ from '../../assets/forms/DDJJ.png'
import firmaDoc from '../../assets/firmaDoc.png'
import selloDoc from '../../assets/selloDoc.png'




const ReactPDF = (props) => {



  const props0 = {
    nombre: '',
    apellido: '',
    tipoDeDocumento: '',
    dni: '',
    fechaDeNacimiento: '',
    domicilio: '',
    localidad: '',
    telefonoParticular: '',
    telefonoCelular: '',
    email: '',
    obraSocial: '',
    firma: ''
  }

  const props1 = {
    name: '',
    lastName: '',
    documentType: '',
    document: '',
    birthday: '',
    adress: '',
    location: '',
    state: '',
    CP: '',
    vinculo: '',
    particularPhone: '',
    celphone: '',
    mail: '',
    medicalSecurity: '',
  }

  const props2 = {
    nombreYApellido: '',
    tipoYNumeroDeDoc: '',
    matricula: '',
    especialidad: '',
    telefonoParticular: '',
    telefonoCelular: '',
    email: '',
    historiaClinica: '',
    arritmiaAngor: '',
    saludMental: '',
    saludMentalEspecificar: '',
    alergia: '',
    embarazo: '',
    maquinaria: '',
    diagnostico: '',
    tratamiento: ''
  }
    
  return (
    
    
    <Document>
      <Page size='A4'>

        <View style={styles.container}>
          <Image
            style={styles.image}
            src={DDJJ}
          />

          {/* datos usuario */}
          <Text style={styles.text}> {props.props[0] ? props.props[0].nombre : props0.nombre} {props.props[0] ? props.props[0].apellido : props0.apellido}</Text>
          <Text style={styles.text41}> {props.props[0] ? props.props[0].nombre : props0.nombre} {props.props[0] ? props.props[0].apellido : props0.apellido}</Text>
          <Text style={styles.text2}> {props.props[0] ? props.props[0].tipoDeDocumento : props0.tipoDeDocumento} {props.props[0] ? props.props[0].dni : props0.dni}</Text>
          <Text style={styles.text4}> {props.props[0] ? props.props[0].fechaDeNacimiento : props0.fechaDeNacimiento}</Text>
          <Text style={styles.text3}> {props.props[0] ? props.props[0].domicilio : props0.domicilio}</Text>
          <Text style={styles.text5}> {props.props[0] ? props.props[0].localidad : props0.localidad}</Text>
          <Text style={styles.text6}> {props.props[0] ? props.props[0].telefonoParticular : props0.telefonoParticular}</Text>
          <Text style={styles.text7}> {props.props[0] ? props.props[0].telefonoCelular : props0.telefonoCelular}</Text>
          <Text style={styles.text8}> {props.props[0] ? props.props[0].email : props0.email}</Text>
          <Text style={styles.text9}> {props.props[0] ? props.props[0].obraSocial : props0.obraSocial}</Text>
          <Text style={styles.text38}> {props.props[0] ? props.props[0].fechaDelDia.slice(0, 10) : "  /  /  "}</Text>

          {/* datos tutor */}


          <Text style={styles.text26}> {props.props[1] ? props.props[1].name : props1.name} {props.props[1] ? props.props[1].lastName : props1.lastName}</Text>
          <Text style={styles.text27}> {props.props[1] ? props.props[1].documentType : props1.documentType} {props.props[1] ? props.props[1].document : props1.document} </Text>
          <Text style={styles.text28}> {props.props[1] ? props.props[1].birthday : props1.birthday}</Text>
          <Text style={styles.text29}> {props.props[1] ? props.props[1].adress : props1.adress} </Text>
          <Text style={styles.text30}> {props.props[1] ? props.props[1].location : props1.location} </Text>
          <Text style={styles.text31}> {props.props[1] ? props.props[1].state : props1.state} </Text>
          <Text style={styles.text32}> {props.props[1] ? props.props[1].CP : props1.CP} </Text>
          <Text style={styles.text33}> {props.props[1] ? props.props[1].vinculo : props1.vinculo} </Text>
          <Text style={styles.text34}> {props.props[1] ? props.props[1].particularPhone : props1.particularPhone} </Text>
          <Text style={styles.text35}> {props.props[1] ? props.props[1].celphone : props1.celphone} </Text>
          <Text style={styles.text36}> {props.props[1] ? props.props[1].mail : props1.mail} </Text>
          <Text style={styles.text37}> {props.props[1] ? props.props[1].medicalSecurity : props1.medicalSecurity} </Text>



         {/* datos médico */}

         

         
          <Text style={styles.text10}> Fernandez Vargas Martina</Text>
          <Text style={styles.text11}> DNI 93.578.641</Text>
          <Text style={styles.text12}>178.139</Text>
          <Text style={styles.text13}> Médica general y/o familiar</Text>
          <Text style={styles.text14}> {props.props[2] ? props.props[2].telefonoParticular : props2.telefonoParticular}</Text>
          <Text style={styles.text15}>+54 9 11-2252-3192</Text>
          <Text style={styles.text16}>dramweed@gmail.com</Text>
          <Text className='text-xs' style={styles.text17}> {props.props[2] ? props.props[2].historiaClinica : props2.historiaClinica}</Text>
          
          {
            props.props[2]
            ? props.props[2].arritmiaAngor === 'no'
            ? <Text style={styles.text18}>X</Text>
            : <Text style={styles.text18b}>X</Text>
            : props2.arritmiaAngor === 'no'
            ? <Text style={styles.text18}>X</Text>
            : <Text style={styles.text18b}>X</Text>
          }
          {
            props.props[2]
            ? props.props[2].saludMental === 'no'
            ? <Text style={styles.text19}>X</Text>
            : <Text style={styles.text19b}>X</Text>
            : props2.saludMental === 'no'
            ? <Text style={styles.text19}>X</Text>
            : <Text style={styles.text19b}>X</Text>
          }

         
          <Text style={styles.text20}>{props.props[2] ? props.props[2].saludMentalEspecificar : props2.saludMentalEspecificar}</Text>

          {
            props.props[2]
            ? props.props[2].alergia === 'no'
            ? <Text style={styles.text21}>X</Text>
            : <Text style={styles.text21b}>X</Text>
            : props2.alergia === 'no'
            ? <Text style={styles.text21}>X</Text>
            : <Text style={styles.text21b}>X</Text>
          }
          {
            props.props[2]
            ? props.props[2].embarazo === 'no'
            ? <Text style={styles.text22}>X</Text>
            : <Text style={styles.text22b}>X</Text>
            : props2.embarazo === 'no'
            ? <Text style={styles.text22}>X</Text>
            : <Text style={styles.text22b}>X</Text>
          }
          {
            props.props[2]
            ? props.props[2].maquinaria === 'no'
            ? <Text style={styles.text23}>X</Text>
            : <Text style={styles.text23b}>X</Text>
            : props2.maquinaria === 'no'
            ? <Text style={styles.text23}>X</Text>
            : <Text style={styles.text23b}>X</Text>
          }


          <Text style={styles.text24}>{props.props[2] ? props.props[2].diagnostico : props2.diagnostico}</Text>
          <Text style={styles.text25}>{props.props[2] ? props.props[2].tratamiento : props2.tratamiento}</Text>
          <Text style={styles.text39}>{props.props[2] ? props.props[2].fechaDelDia.slice(0, 10) + 'Buenos Aires' : "  /  /   Buenos Aires"}</Text>
          
          
            <Image src={firmaDoc} alt='firmaDoc' style={styles.image2} />
            <Text style={styles.text40}>Fernandez Vargas Martina</Text>
          

          <Image src={selloDoc} alt='selloDoc' style={styles.image3} />

          {/* firma usuario */}
          <Image src={props.props[0] ? props.props[0].firma : props0.firma} alt='firmaUsuario' style={styles.image4} />
          <Text style={styles.text42}> {props.props[0] ? props.props[0].provincia : props0.provincia}</Text>
       


        </View>
      </Page>
    </Document>
    

  )
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  image: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  image2: {
    position: 'absolute',
    width: '50',
    height: '50',
    top: '85%',
    left: '10%'
  },
  image3: {
    position: 'absolute',
    width: '75',
    height: '50',
    top: '85%',
    left: '42%'
  },
  image4: {
    position: 'absolute',
    width: '75',
    height: '50',
    top: '85%',
    left: '72%'
  },
  text: {
    position: 'absolute',
    top: '21.5%',
    left: '26.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text2: {
    position: 'absolute',
    top: '23%',
    left: '26.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text3: {
    position: 'absolute',
    top: '24.7%',
    left: '26.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text4: {
    position: 'absolute',
    top: '23%',
    right: '26.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text5: {
    position: 'absolute',
    top: '26.2%',
    left: '26.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text6: {
    position: 'absolute',
    top: '27.8%',
    left: '33%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text7: {
    position: 'absolute',
    top: '27.8%',
    right: '26.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text8: {
    position: 'absolute',
    top: '29.5%',
    left: '26.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text9: {
    position: 'absolute',
    top: '31.1%',
    left: '26.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text10: {
    position: 'absolute',
    top: '53.4%',
    left: '26.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text11: {
    position: 'absolute',
    top: '53.4%',
    right: '11%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text12: {
    position: 'absolute',
    top: '55.1%',
    left: '26.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text13: {
    position: 'absolute',
    top: '55.1%',
    left: '55%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text14: {
    position: 'absolute',
    top: '56.8%',
    left: '33%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text15: {
    position: 'absolute',
    top: '56.8%',
    left: '64%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text16: {
    position: 'absolute',
    top: '58.2%',
    left: '33%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text17: {
    position: 'absolute',
    top: '61%',
    left: '15%',
    right: '5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '7pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text18: {
    position: 'absolute',
    top: '68%',
    left: '65.8%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text18b: {
    position: 'absolute',
    top: '68%',
    left: '70.4%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text19: {
    position: 'absolute',
    top: '69.7%',
    left: '65.8%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text19b: {
    position: 'absolute',
    top: '69.7%',
    left: '70.4%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text20: {
    position: 'absolute',
    top: '73.7%',
    left: '14.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text21: {
    position: 'absolute',
    top: '75.8%',
    left: '65.8%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text21b: {
    position: 'absolute',
    top: '75.8%',
    left: '70.4%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text22: {
    position: 'absolute',
    top: '78.1%',
    left: '65.8%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text22b: {
    position: 'absolute',
    top: '78.1%',
    left: '70.4%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text23: {
    position: 'absolute',
    top: '80%',
    left: '65.8%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text23b: {
    position: 'absolute',
    top: '80%',
    left: '70.4%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text24: {
    position: 'absolute',
    top: '83%',
    left: '14.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text25: {
    position: 'absolute',
    top: '86%',
    left: '14.5%',
    paddingRight:"11%",
    transform: 'translate(-50%, -50%)',
    fontSize: '7pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text26: {
    position: 'absolute',
    top: '37.5%',
    left: '26.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text27: {
    position: 'absolute',
    top: '37.5%',
    left: '62%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text28: {
    position: 'absolute',
    top: '37.5%',
    left: '85.3%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text29: {
    position: 'absolute',
    top: '39.3%',
    left: '20%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text30: {
    position: 'absolute',
    top: '39.3%',
    left: '55%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text31: {
    position: 'absolute',
    top: '39.3%',
    left: '72%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text32: {
    position: 'absolute',
    top: '39.3%',
    left: '86%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text33: {
    position: 'absolute',
    top: '40.7%',
    left: '44.8%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text34: {
    position: 'absolute',
    top: '42.1%',
    left: '33.5%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text35: {
    position: 'absolute',
    top: '42.1%',
    left: '63.4%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text36: {
    position: 'absolute',
    top: '43.8%',
    left: '26%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text37: {
    position: 'absolute',
    top: '45.5%',
    left: '26%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text38: {
    position: 'absolute',
    top: '100%',
    left: '77%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text39: {
    position: 'absolute',
    top: '100%',
    left: '14.5%',
    paddingRight:"11%",
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text40: {
    position: 'absolute',
    top: '96.2%',
    left: '16%',
    paddingRight:"11%",
    transform: 'translate(-50%, -50%)',
    fontSize: '7pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text41: {
    position: 'absolute',
    top: '96.2%',
    right: '1%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },
  text42: {
    position: 'absolute',
    top: '100%',
    right: '1%',
    transform: 'translate(-50%, -50%)',
    fontSize: '10pt',
    fontWeight: 'bold',
    color: 'black',
    textShadow: '2px 2px 4px #000000',
  },

})
export default ReactPDF

